export default "__VITE_ASSET__034065c0__"